import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

const WebServerNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="webserver" />;
};

export default WebServerNode;
